module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-BOOSTER-GREEN-1.cb2aa726.jpg";